// import { useActionPlanContext } from 'hooks/ActionPlanContext';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';

interface SearchFilterBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedPolicyAreas: string[]; // Multiple selections allowed
  setSelectedPolicyAreas: (areas: string[]) => void;
}

const SearchFilterBar: React.FC<SearchFilterBarProps> = ({
  searchTerm,
  setSearchTerm,
  // selectedPolicyAreas,
  // setSelectedPolicyAreas,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  // const { getUniqueResponsibleInstitutions } = useActionPlanContext();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { locale } = useRouter();

  // const toggleDropdown = () => {
  //   setIsDropdownOpen(!isDropdownOpen);
  // };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleOutsideClick = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsDropdownOpen(false); // Dropdown dışında bir yere tıklandığında kapat
    }
  };

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleOutsideClick); // Tıklama olayını dinle
    } else {
      document.removeEventListener('mousedown', handleOutsideClick); // Tıklama olayını kaldır
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick); // Cleanup
    };
  }, [isDropdownOpen]);

  // const handleCheckboxChange = (institution: string) => {
  //   // Eğer checkbox zaten seçiliyse kaldır, değilse ekle
  //   if (selectedPolicyAreas.includes(institution)) {
  //     setSelectedPolicyAreas(selectedPolicyAreas.filter((area) => area !== institution));
  //   } else {
  //     setSelectedPolicyAreas([...selectedPolicyAreas, institution]);
  //   }
  // };

  return (
    <div className="sticky-search-bar">
      <div className="full-wrap-search-holder">
        <div className="search-bar-container">
          <div
            className="search-nav"
            style={{
              transform: isScrolled
                ? 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
                : 'translate3d(0px, 70px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
              transition: 'transform 400ms ease',
              transformStyle: 'preserve-3d',
            }}
          >
            <div className="a-filter-filter-form-block-top full w-form">
              <div className="a-filter-form-top" aria-label="Search">
                <div className="a-filter-search">
                  <div className="a-filter-search-icon-wrapper">
                    <img
                      alt=""
                      loading="lazy"
                      src="/images/66b92a5542a15fc71d280486_search.svg"
                      className="a-icon-small"
                    />
                  </div>
                  <input
                    className="a-filter-search-text-field jetboost-list-search-input-xr5q w-input"
                    type="text"
                    maxLength={256}
                    placeholder={locale?.includes('tr') ? 'Ara...' : 'Search...' }
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>

                {/* <div className="a-filter-dropdown-wrapper" ref={dropdownRef}>
                  <div
                    className="a-filter-dropdown-large w-dropdown"
                    style={isDropdownOpen ? { zIndex: 901 } : {}}
                  >
                    <div
                      id="w-dropdown-toggle-3"
                      className={`a-filter-dropdown-toggle w-dropdown-toggle ${isDropdownOpen ? 'w--open' : ''}`}
                      onClick={toggleDropdown}
                    >
                      <div className="a-subheading-regular">
                        {locale?.includes('tr') ? 'Sorumlu Kurum : 'Responsible Institution' }
                        </div>
                      <div className="a-icon-small w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M10.5829 6.00007L7.99628 8.58674L5.40961 6.00007C5.14961 5.74007 4.72961 5.74007 4.46961 6.00007C4.20961 6.26007 4.20961 6.68007 4.46961 6.94007L7.52961 10.0001C7.78961 10.2601 8.20961 10.2601 8.46961 10.0001L11.5296 6.94007C11.7896 6.68007 11.7896 6.26007 11.5296 6.00007C11.2696 5.74673 10.8429 5.74007 10.5829 6.00007Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <nav
                      id="w-dropdown-list-3"
                      className={`a-filter-dropdown-list w-dropdown-list ${isDropdownOpen ? 'w--open' : ''}`}
                    >
                      {getUniqueResponsibleInstitutions().map((item, index) => (
                        <label key={item} className="w-checkbox a-filter-checkbox-field">
                          <div
                            className={`w-checkbox-input w-checkbox-input--inputType-custom a-filter-checkbox ${selectedPolicyAreas.includes(item) ? 'w--redirected-checked' : ''}`}
                          ></div>
                          <input
                            id={`checkbox-${index}`}
                            type="checkbox"
                            name="policy-area"
                            value={item}
                            style={{ opacity: '0', position: 'absolute', zIndex: -1 }}
                            onChange={() => handleCheckboxChange(item)}
                            checked={selectedPolicyAreas.includes(item)}
                          />
                          <label className="a-filter-label w-form-label" htmlFor={`checkbox-${index}`}>
                            {item}
                          </label>
                        </label>
                      ))}
                    </nav>
                  </div>
                 
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchFilterBar;
